<template>
  <div>
    <ModuleComponent :module-data="moduleData" @changed="item = $event">
      <template v-slot:tableFilters="{ filters }">
        <b-container fluid>
          <b-row>
            <b-col cols="3" sm="3" md="3">
              <b-form-group :label="t('GLOBAL.MODULEGROUP')">
                <v-select2
                  v-model="filters.moduleGroupId.value"
                  endPoint="moduleGroups"
                  :placeholder="t('GLOBAL.MODULEGROUP')"
                ></v-select2>
              </b-form-group>
            </b-col>
            <b-col cols="3" sm="3" md="3">
              <b-form-group :label="t('GLOBAL.NAME')">
                <b-form-input
                  name="name"
                  v-model="filters.name.value"
                  :placeholder="t('GLOBAL.NAME')"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-container>
      </template>
      <template v-slot:form="{ item }">
        <b-row>
          <b-col cols="12" sm="12" md="12">
            <b-form-group :label="t('GLOBAL.NAME')">
              <b-form-input
                name="name"
                v-model="item.name"
                :placeholder="t('GLOBAL.NAME')"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="12" md="12">
            <b-form-group :label="t('GLOBAL.ENDPOINT')">
              <b-form-input
                name="endpoint"
                v-model="item.endPoint"
                :placeholder="t('GLOBAL.ENDPOINT')"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="12" md="12">
            <b-form-group :label="t('GLOBAL.MODULEGROUP')">
              <v-select2
                v-model="item.moduleGroupId"
                :text="item.moduleGroup ? item.moduleGroup.name : ''"
                endPoint="moduleGroups"
                :placeholder="t('GLOBAL.MODULEGROUP')"
              ></v-select2>
            </b-form-group>
          </b-col>
        </b-row>
      </template>
    </ModuleComponent>
  </div>
</template>

<script>
// http://core.datadns.net:5000/swagger/index.html#model-Module
export default {
  name: "modules",
  data() {
    return {
      item: {},
      moduleData: {
        name: "modules",
        primaryKey: "id",
        table: {
          sortBy: "name",
          sortDesc: false,
          graphqlQuery: `
							id,name,endPoint,moduleGroup{name}
						`,
          headers: [
            { text: "ID", value: "id", width: "70" },
            { text: this.t("GLOBAL.NAME"), value: "name" },
            { text: this.t("GLOBAL.ENDPOINT.D"), value: "endPoint" },
            { text: this.t("GLOBAL.GROUP.D"), value: "moduleGroup.name" }
          ],
          filters: {
            name: {
              type: "string",
              searchBy: "beginsWith",
              value: null
            },
            moduleGroupId: {
              type: "number",
              value: null
            }
          }
        },
        form: {
          maxWidth: "80%"
        }
      }
    };
  }
};
</script>
